import logger from '../utils/logger';

interface FeatureFlag {
  id: string;
  enabled: boolean;
  conditions?: any;
}

interface RuntimeConfig {
  'frontend:applicationInsightsConnectionString': string;
  feature_management?: {
    feature_flags: FeatureFlag[];
  };
  [key: string]: any;
}

function getBackendUrl(): string {
  // Allow override via build-time env (used by docker-compose with Vite proxy)
  const override = import.meta.env.VITE_BACKEND_URL;
  if (override !== undefined && override !== null) {
    return override;
  }

  const hostname = window.location.hostname;

  // Local development - use HTTPS proxy (https://localhost:443 → http://localhost:8000)
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'https://localhost';
  }

  // Production/staging - use api subdomain pattern
  return `${window.location.protocol}//api.${hostname}`;
}

class ConfigService {
  private config: RuntimeConfig | null = null;
  private backendUrl = getBackendUrl();

  async load(): Promise<RuntimeConfig> {
    const response = await fetch(`${this.backendUrl}/api/config/frontend`, {
      credentials: 'include',
    });
    const data: RuntimeConfig = await response.json();
    this.config = data;
    logger.debug('Config loaded');
    return data;
  }

  get(): RuntimeConfig {
    if (!this.config) throw new Error('Config not loaded');
    return this.config;
  }

  getBackendUrl(): string {
    return this.backendUrl;
  }
}

export const configService = new ConfigService();
export type { RuntimeConfig, FeatureFlag };
